// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-personal-data {
    background-color: rgb(236, 236, 236);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 500px;
    width: 80%;
    height: 500px;
    border: 1px solid rgb(187, 187, 187);
    border-radius: 12px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px 20px;
}

.form-personal-data > label {
  width: 80%;
}

.register-inputs {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 400px;
    width: 100%;
    height: 30px;
    border: none;
    margin-bottom: 10px;
    border-bottom: 0.125rem solid rgb(170, 170, 170);
}

.register-inputs:focus {
    outline: none;
}

.button-30 {
    margin-top: 50px;
    align-items: center;
    appearance: none;
    background-color: #FCFCFD;
    border-radius: 4px;
    border-width: 0;
    box-shadow: rgba(45, 35, 66, 0.4) 0 2px 4px,rgba(45, 35, 66, 0.3) 0 7px 13px -3px,#D6D6E7 0 -3px 0 inset;
    box-sizing: border-box;
    color: #36395A;
    cursor: pointer;
    display: inline-flex;
    font-family: "JetBrains Mono",monospace;
    height: 48px;
    justify-content: center;
    line-height: 1;
    list-style: none;
    overflow: hidden;
    padding-left: 16px;
    padding-right: 16px;
    position: relative;
    text-align: left;
    text-decoration: none;
    transition: box-shadow .15s,transform .15s;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    white-space: nowrap;
    will-change: box-shadow,transform;
    font-size: 18px;
  }
  
  .button-30:focus {
    box-shadow: #D6D6E7 0 0 0 1.5px inset, rgba(45, 35, 66, 0.4) 0 2px 4px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset;
  }
  
  .button-30:hover {
    box-shadow: rgba(45, 35, 66, 0.4) 0 4px 8px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset;
    transform: translateY(-2px);
  }
  
  .button-30:active {
    box-shadow: #D6D6E7 0 3px 7px inset;
    transform: translateY(2px);
  }`, "",{"version":3,"sources":["webpack://./src/style/Register/Register.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,wGAAwG;IACxG,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,uCAAuC;IACvC,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,0CAA0C;IAC1C,iBAAiB;IACjB,yBAAyB;IACzB,0BAA0B;IAC1B,mBAAmB;IACnB,iCAAiC;IACjC,eAAe;EACjB;;EAEA;IACE,qIAAqI;EACvI;;EAEA;IACE,0GAA0G;IAC1G,2BAA2B;EAC7B;;EAEA;IACE,mCAAmC;IACnC,0BAA0B;EAC5B","sourcesContent":[".form-personal-data {\r\n    background-color: rgb(236, 236, 236);\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    max-width: 500px;\r\n    width: 80%;\r\n    height: 500px;\r\n    border: 1px solid rgb(187, 187, 187);\r\n    border-radius: 12px;\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    padding: 20px 20px;\r\n}\r\n\r\n.form-personal-data > label {\r\n  width: 80%;\r\n}\r\n\r\n.register-inputs {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    max-width: 400px;\r\n    width: 100%;\r\n    height: 30px;\r\n    border: none;\r\n    margin-bottom: 10px;\r\n    border-bottom: 0.125rem solid rgb(170, 170, 170);\r\n}\r\n\r\n.register-inputs:focus {\r\n    outline: none;\r\n}\r\n\r\n.button-30 {\r\n    margin-top: 50px;\r\n    align-items: center;\r\n    appearance: none;\r\n    background-color: #FCFCFD;\r\n    border-radius: 4px;\r\n    border-width: 0;\r\n    box-shadow: rgba(45, 35, 66, 0.4) 0 2px 4px,rgba(45, 35, 66, 0.3) 0 7px 13px -3px,#D6D6E7 0 -3px 0 inset;\r\n    box-sizing: border-box;\r\n    color: #36395A;\r\n    cursor: pointer;\r\n    display: inline-flex;\r\n    font-family: \"JetBrains Mono\",monospace;\r\n    height: 48px;\r\n    justify-content: center;\r\n    line-height: 1;\r\n    list-style: none;\r\n    overflow: hidden;\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n    position: relative;\r\n    text-align: left;\r\n    text-decoration: none;\r\n    transition: box-shadow .15s,transform .15s;\r\n    user-select: none;\r\n    -webkit-user-select: none;\r\n    touch-action: manipulation;\r\n    white-space: nowrap;\r\n    will-change: box-shadow,transform;\r\n    font-size: 18px;\r\n  }\r\n  \r\n  .button-30:focus {\r\n    box-shadow: #D6D6E7 0 0 0 1.5px inset, rgba(45, 35, 66, 0.4) 0 2px 4px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset;\r\n  }\r\n  \r\n  .button-30:hover {\r\n    box-shadow: rgba(45, 35, 66, 0.4) 0 4px 8px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset;\r\n    transform: translateY(-2px);\r\n  }\r\n  \r\n  .button-30:active {\r\n    box-shadow: #D6D6E7 0 3px 7px inset;\r\n    transform: translateY(2px);\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
